module.exports = __webpack_public_path__ + "static/media/rotor-top.210498d0.svg";